import { Fotter } from '../../components';
import { useEffect } from 'react';

import aboutUsBanner from './images/aboutUsBanner.jpg';
import ceo from './images/ceo.jpg';
import icon from '../HomePage/components/CustomerStories/images/customVideoPlayButton.png';
import aboutUs from '../HomePage/components/AboutUs/images/aboutus.png';
import photo from './images/photo.png'

import styles from './index.module.css';


const text = {
    cn: {
        title: '关于我们',
        content1: '我们是ProLogue LLC，中文名为序幕体育，位于美国新泽西州。这是一家以见证和记录动人的体育人和体育故事为宗旨的体育内容相关服务公司。',
        content2: '它分为几个业务内容部分，第一为视频内容的拍摄和制作，包括纪录片、宣传片、以及一些为播出平台所需生产的节目和直播活动。第二，为体育相关的合作方及客户的需求提供包括经纪、策划、联络、执行和运营等服务。目前，ProLogue已与NBA中国、布鲁克林篮网队、Priority、WME、GZY、River Light、沃瑟曼体育经纪公司、腾讯和快手体育、壹球体育、疯狂体育等形成了合作关系。',
        ceo: {
            title: '主理人',
            description: '沈洋，Lisa Hsu作为篮球媒体人、资深记者在篮球领域深耕十数年，因为工作成绩的突出成为了业内的标杆级人物，并且获得了许多荣誉。2022年初，开始涉足纪录片领域，指导拍摄了纪录片《投中那颗logo shot》开始正式从采访者过渡成为了讲故事的人。见证、记录甚至是推动体育人和体育故事的发生是沈洋一直以来的追寻，她一直没有忘记自己的偶像科比布莱恩特曾经对自己说的话，“DREAM BIG”梦想最大！她也会继续科比在退役之后所从事的领域，为想听故事的人讲出更多一个个真实和动人的体育故事。让更多人领会到体育所带给人的那种共通的情感共鸣，让人们通过体育去相信梦想存在，奇迹存在。'
        },
        photographer: {
            title: '摄影师',
            description: 'Jeremy Zheng是一名来自加拿大多伦多的电影人，他也是加拿大摄影师协会(CSC)的会员。他专注拍摄体育和音乐相关题材的内容，比如运动摄影，篮球纪录片以及音乐录影带。他合作过的品牌包括腾讯，咪咕视频，加拿大篮球国家队，NBA多伦多猛龙队等等。'
        }
    },
    en: {
        title: 'ABOUT US',
        content1: 'ProLogue (Chinese: 序幕) LLC is a sports media content production company based out of New Jersey, USA. We aim to serve our fans by capturing and presenting authentic, unique and moving stories in the world of sports and its people.',
        content2: 'ProLogue specializes in directing, filming and post-production of video content, including documentaries, promos and other materials serving live and OTT platforms. We also provide customized all-encompassing services covering planning, coordination, execution and operational phases of sporting events.',
        ceo: {
            title: 'CEO',
            description: 'Lisa Hsu is a seasoned journalist and basketball media professional with more than a decade of experience in the industry. Through hard work and her tenacious pursuit for excellence over the years, Lisa has won many accolades and awards as a reporter and became a torchbearer among her peers. In early 2022, Lisa began transitioning into her new role as a storyteller in the field of documentaries, directing and executive producing docuseries “Logo Shot”. As someone whose passion always resides in documenting, spotlighting stories of sports and people in sports, Lisa keeps dear to her heart what the late Kobe Bryant once said to her – Dream Big. Part of that became Lisa’s motivation to advance what became Kobe’s passion after retiring from playing basketball – to tell authentic and moving sports stories, allow them to echo through the heartstrings and emotions of the mass. Lisa is a strong believer that sports can serve as the connective tissue between fans and their dreams.'
        },
        photographer: {
            title: 'PHOTOGRAPHER',
            description: "Jeremy Zheng, as known as 'Peace, is a cinematographer, and sports photographer based in Toronto, Canada. Jeremy is also proudly a Canadian Society of Cinematographers(CSC member. He is proficient and passionate about making films about sports and music, especially basketball documentaries and music videos. The clients he has cooperated with include Tencent, China Mobile Migu, Canada Basketball, Toronto Raptors, etc."
        }
    }
}

const AboutUs = (props) => {
    const { l, setIsBlack, path } = props;

    useEffect(() => {
        if (path === 'About US') {
            window.addEventListener('scroll', () => {
                if (document.getElementById('custom-page')?.getBoundingClientRect().top < -document.getElementById('c-banner-h')?.clientHeight + 60) {
                    setIsBlack(true);
                } else {
                    setIsBlack(false);
                }
            })
        }

        return () => {
            window.removeEventListener('scroll', () => { });
        }
    }, [])

    return (
        <div className={styles['page']} id='custom-page'>
            <div className={styles['banner']}>
                <img src={aboutUsBanner} id='c-banner-h' className={styles['banner-img1']} alt='' />
                {/* <img src={aboutUsBanner} className={styles['banner-img']} /> */}
                <div className={styles['banner-title']}>{text[l]['title']}</div>
            </div>
            <div style={{ height: '80vh', position: 'relative' }}>
                <div className={styles['box']}>
                    <div className={styles['box-left']}>
                        <div className={styles['title1']}>{text[l]['title']}</div>
                        <div className={styles['line']}>&nbsp;</div>
                        <div className={styles['content1']}>
                            {text[l]['content1']}
                        </div>
                        <div className={styles['content2']}>
                            {text[l]['content2']}
                        </div>
                    </div>
                    <div className={styles['box-right']}>
                        <img src={aboutUs} className={styles['right-img']} alt='' />
                    </div>
                </div>
            </div>
            <div className={styles['ceo-box']}>
                <div className={styles['left']}>
                    <img src={ceo} className={styles['ceo-img']} alt='' />
                    <img src={icon} className={styles['ceo-video-icon']} onClick={() => {
                        window.Player('c35052oo0f7');
                    }} alt='' />
                </div>
                <div className={styles['right']}>
                    <div className={styles['title']}>{text[l]['ceo']['title']}</div>
                    <div
                        className={styles['ceo-des']}
                        style={{
                            lineHeight: l === 'cn' ? '28px' : '24px'
                        }}
                    >{text[l]['ceo']['description']}</div>
                </div>
            </div>
            <div style={{ height: '80vh', position: 'relative' }}>
                <div className={styles['box']}>
                    <div className={styles['box-left']}>
                        <div className={styles['title1']}>{text[l]['photographer']['title']}</div>
                        <div className={styles['line']}>&nbsp;</div>
                        <div className={styles['content1']}>
                            {text[l]['photographer']['description']}
                        </div>
                    </div>
                    <div className={styles['box-right']}>
                        <img src={photo} className={styles['right-img']} alt='' />
                    </div>
                </div>
            </div>
            <Fotter l={l} />
        </div>
    )
}

export default AboutUs;